import Swiper from 'swiper/bundle';
import PhotoNavigate from '../../class/Photo/Navigate';
import Image from '../../class/Image';
import '../../block/sliderCursor';

class Curator {
    constructor() {
        this.events();
    }

    events() {
        this.swipers();
        this.presentation();
        $(window).on('resize', () => {
            this.presentation();
        });
        this.objectsInner();
        this.numbers();
        this.imageModal();
        this.photosObjects();
        this.PhotoNavigate();
    }

    swipers() {
        // Всем отсупы слева
        if ($(window).width() > 576) {
            $('[cursor-status].swiper-container').css('padding-left', $('.container').offset().left);
        }
        if ($(window).width() > 576) {
            $('.swiper-container .slider-navigation').css('padding-right', $('.container').offset().left + 15);
        }

        // Контейнер для мобилки
        if ($(window).width() <= 576) {
            $('.swiper-1').wrap('<div class="container"></div>');
        }

        var options = {
            speed: 500,
            navigation: {
                nextEl: '.arrows-nav__right',
                prevEl: '.arrows-nav__left',
            },
            on: {
                init: function (event) {
                    $($(this)[0].$el).find('[data-all-count]').html(event.slides.length);
                },
                slideChange: function (event) {
                    var swiperElem = $($(this)[0].$el);

                    if (swiperElem.hasClass('swiper-2')) {

                    }

                    swiperElem.find('[data-active-count]').html(event.activeIndex + 1);

                    if ($(window).width() > 1200) {
                        if (event.realIndex == 0) {
                            swiperElem.stop().animate({
                                'padding-left': $('.container').offset().left + 'px'
                            }, 250);
                        }

                        if (event.realIndex == 1) {
                            swiperElem.stop().animate({
                                'padding-left': 0
                            }, 250);
                        }
                    }
                }
            }
        }

        // История компании
        new Swiper('.swiper-1', $.extend(options, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            breakpoints: {
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 155
                },
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 20
                },
                320: {
                    spaceBetween: 20
                }
            }
        }));

        // Экосистема сервисов
        new Swiper('.swiper-2', $.extend(options, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 20
                },
                320: {
                    spaceBetween: 20
                }
            }
        }));
    }

    presentation() {
        $('.section-presentation-container, .section-presentation__left').css('margin-left', $('.container').offset().left + 15);
    }

    objectsInner() {
        var width = $(window).width();

        $('.objects-wrapper').each((i, item) => {
            var btn = $('[show-objects]').eq(i),
                count = parseInt($('[data-numbers-count]').eq(i).attr('data-numbers-count'));

            if (width <= 576) {
                $(item).find('.object-inner').slice(4).hide();

                if (count > 4) {
                    btn.parent().show();
                }
            } else if (width < 991) {
                $(item).find('.object-inner').slice(6).hide();

                if (count > 6) {
                    btn.parent().show();
                }
            }
        });

        $(document).on('click', '[show-objects]', (e) => {
            $(e.currentTarget).parents('section:eq(0)').find('.object-inner').slideDown("slow");
            $(e.currentTarget).parent().hide("slow");
        });
    }

    numbers() {
        var classId = 0,
            classes = [
                'object-item__bg-transparent object-item__bordered object-item__circle',
                'object-item__bg-white object-item__bordered',
                'object-item__bg-gray object-item__circle',
                'object-item__bg-gray',
                'object-item__bg-transparent object-item__bordered object-item__circle',
                'object-item__bg-white',
                'object-item__bg-white object-item__circle',
                'object-item__bg-white',
                'object-item__bg-transparent object-item__bordered object-item__circle'
            ],
            getClass = function () {
                var result = classes[classId];

                classId++;
                if (classId > classes.length - 1) {
                    classId = 0;
                }

                return result;
            };

        $('[numbers-item]').each(function () {
            $(this).addClass(getClass());
        });
    }

    imageModal() {
        $('[image-item]').on('click', function () {
            $('#getPhoto [data-html="image"]').html('<img src="' + Image.srcOriginal($(this).find('[src]').attr('src')) + '">');
            $('#getPhoto').modal('show');
        });
    }

    photosObjects() {
        var parent = $('.section-photos__grid'),
            btn = $('[show-photos]');

        parent.each(function () {
            $(this).find('.section-photos__item').slice(8).hide();
        });

        $(document).on('click', '[show-photos]', function () {
            parent.find('.section-photos__item').slideDown("slow");
            btn.fadeOut("slow");
            btn.parents('.section-photos__btns').hide();
        });
    }

    PhotoNavigate() {
        new PhotoNavigate({
            total: $('[image-item]').length,
            elem: {
                btn: {
                    next: '[data-photo-next]',
                    prev: '[data-photo-prev]'
                },
                total: '[data-all-count]',
                current: '[data-active-count]',
                item: '[image-item]',
                image: '[items-modal-photo] [data-html="image"]'
            },
        });
    }
}

new Curator();